import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MyInstallmentsService, Installment, InstallmentsSummary } from '../../../services/my-installments.service';
import { TranslatePipe } from '../../../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-my-installments',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './my-installments.html',
})
export class MyInstallmentsComponent implements OnInit {
  summary: InstallmentsSummary | null = null;
  installments: Installment[] = [];
  loading = true;
  error: string | null = null;

  // Payment modal state
  showPaymentModal = false;
  selectedInstallment: Installment | null = null;
  paymentType = 'full';
  paymentAmount = 0;
  paymentAttachment: File | null = null;
  paymentError: string | null = null;
  paymentSubmitting = false;
  paymentSuccess: string | null = null;

  constructor(private service: MyInstallmentsService) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.error = null;
    this.service.getInstallments().subscribe({
      next: (res) => {
        this.summary = res.summary;
        // Sort installments by number
        this.installments = (res.installments || []).sort((a, b) => a.installmentNumber - b.installmentNumber);
        this.loading = false;
      },
      error: (err) => {
        this.error = err.message || 'Failed to load installments data';
        this.loading = false;
      }
    });
  }

  getStatusClass(status: string): string {
    switch (status.toLowerCase()) {
      case 'paid':
        return 'badge-success';
      case 'pending':
        return 'badge-warning';
      case 'overdue':
        return 'badge-danger';
      default:
        return 'badge-neutral';
    }
  }

  getTypeLabel(type: string): string {
    return type.replace('_', ' ');
  }

  openPaymentModal(inst: Installment): void {
    this.selectedInstallment = inst;
    this.paymentType = 'full';
    this.paymentAmount = inst.amount || 0;
    this.paymentAttachment = null;
    this.paymentError = null;
    this.paymentSuccess = null;
    this.showPaymentModal = true;
  }

  closePaymentModal(): void {
    this.showPaymentModal = false;
    this.selectedInstallment = null;
  }

  onPaymentFileChange(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.paymentAttachment = file;
    }
  }

  submitPayment(): void {
    if (!this.selectedInstallment) return;

    this.paymentSubmitting = true;
    this.paymentError = null;
    this.paymentSuccess = null;

    const fd = new FormData();
    fd.append('typeForSale', this.paymentType);
    fd.append('amount', String(this.paymentAmount));
    fd.append('installmentId', this.selectedInstallment._id);
    fd.append('installmentNumber', String(this.selectedInstallment.installmentNumber));
    if (this.paymentAttachment) {
      fd.append('attachment', this.paymentAttachment);
    }

    this.service.payInstallment(this.selectedInstallment.dealId, fd).subscribe({
      next: () => {
        this.paymentSubmitting = false;
        this.paymentSuccess = 'Payment submitted successfully!';
        setTimeout(() => {
          this.closePaymentModal();
          this.loadData();
        }, 2000);
      },
      error: (err) => {
        this.paymentSubmitting = false;
        this.paymentError = err.error?.message || err.message || 'Failed to submit payment';
      }
    });
  }
}
